import { useCallback, useEffect, useState } from "react";
import { getChannelHeader, getPosition } from "../../services/customerTouchPoint";

const useChannelHeader = () => {
    const [data1, setData1] = useState([]);

    const fetchData = useCallback(async () => {
        const res = await getChannelHeader();
        let newValue = [];
        if (res.data.code === "0000") {
            const { objectValue } = res.data;
            objectValue.map((item) => {
                newValue.push({ id: item.channel, value: item.header });
            });

            setData1(newValue);
        }
    }, [setData1]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data1];
};

export default useChannelHeader;
